import { Accessor, Setter, createContext, useContext } from "solid-js";
import { FaqArticle, FaqCategory } from "../types";
import { useBookmark } from "~/primitives/bookmark";

interface FaqWidgetContextInterface {
	faqName: Accessor<string>;
	
	categories: Accessor<FaqCategory[]>;
	selected: Accessor<FaqArticle | undefined>;
	setSelected: Setter<FaqArticle | undefined>;
	handleLinkClick: (event: MouseEvent) => void;
	
	search: Accessor<string>;
	setSearch: (value: string) => void;
	searchedArticles: Accessor<FaqCategory[]>;
	
	textToSpeech: () => Promise<string>;
	
	faqDownloadButton: Accessor<HTMLButtonElement | undefined>;
	setFaqDownloadButton: Setter<HTMLButtonElement | undefined>;
	downloadFaq: () => void;
	isDownloading: Accessor<boolean>;
	
	bookmark: ReturnType<typeof useBookmark>;
	hasBookmarked: Accessor<boolean>;
	toggleBookmark: () => void;

	openSheet: Accessor<boolean>;
	setOpenSheet: Setter<boolean>;

	tab: Accessor<"toc" | "bookmarks">;
	setTab: Setter<"toc" | "bookmarks">;
}

export const FaqWidgetContext = createContext<FaqWidgetContextInterface>();

export function useFaqWidget() {
	const context = useContext(FaqWidgetContext);
	if (!context) throw new Error("useFaqWidget must be used within a FaqWidgetProvider");
	return context;
}